/**
 * biin-news-carousel.js
 * Carrusel accesible de noticias: navega con flechas, dots, swipe táctil
 * (Pointer Events + fallback Touch Events) y teclado. No depende de jQuery.
 *
 * Notas:
 *  - Swipe horizontal: drag > 40px → cambia slide. < 40px → tap sin cambio.
 *  - Drag vertical: lo cedemos al scroll nativo de la página.
 *  - NO bloqueamos el click: cuando hay swipe, dejamos que el click fluya
 *    normalmente al <a> "Leer más". El cambio de slide se aplica con
 *    goTo() (scroll programático) sin interferir con la navegación.
 */
(function () {
	'use strict';

	// Umbral mínimo (px) para considerar un arrastre como swipe horizontal.
	var SWIPE_THRESHOLD = 40;
	// Umbral para activar el modo "dragging" (evita falsos positivos).
	var DRAG_ACTIVATE = 8;

	function init(root) {
		if (root.dataset.biinNewsReady === '1') return;
		root.dataset.biinNewsReady = '1';

		var track = root.querySelector('.biin-news-carousel__track');
		var slides = track ? track.children : [];
		var prevBtn = root.querySelector('.biin-news-carousel__nav--prev');
		var nextBtn = root.querySelector('.biin-news-carousel__nav--next');
		var dotsBox = root.querySelector('.biin-news-carousel__dots');

		if (!track || slides.length === 0) return;

		var index = 0;
		var total = slides.length;

		// --- Dots ---
		var dots = [];
		if (dotsBox) {
			dotsBox.innerHTML = '';
			for (var i = 0; i < total; i++) {
				var b = document.createElement('button');
				b.type = 'button';
				b.className = 'biin-news-carousel__dot';
				b.setAttribute('role', 'tab');
				b.setAttribute('aria-label', 'Ir a la noticia ' + (i + 1));
				b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
				(function (target) {
					b.addEventListener('click', function () { goTo(target); });
				})(i);
				dotsBox.appendChild(b);
				dots.push(b);
			}
		}

		function goTo(n, instant) {
			if (n < 0) n = 0;
			if (n >= total) n = total - 1;
			index = n;
			// Posición objetivo: index * ancho del track (cada slide ocupa
			// exactamente clientWidth del track). Es más robusto que
			// slide.offsetLeft porque ese valor es relativo al viewport
			// (que tiene padding/gap de los botones prev/next), no al track.
			var slideW = track.clientWidth;
			track.scrollTo({
				left: index * slideW,
				behavior: instant ? 'auto' : 'smooth'
			});
			update();
		}

		function update() {
			dots.forEach(function (d, i) {
				var active = i === index;
				d.classList.toggle('is-active', active);
				d.setAttribute('aria-selected', active ? 'true' : 'false');
			});
			if (prevBtn) prevBtn.disabled = (index <= 0);
			if (nextBtn) nextBtn.disabled = (index >= total - 1);
		}

		if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
		if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

		// --- Teclado ---
		root.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
			if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
		});

		// Re-evaluar en resize (ancho de slide puede cambiar)
		var resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () { goTo(index, true); }, 100);
		});

		// --- SWIPE con Pointer Events --------------------------------------
		// Solo detecta el swipe para cambiar slide. NO bloquea clicks: el
		// pointerup no llama a preventDefault ni stopPropagation, así que
		// el evento "click" subsiguiente fluye normal al <a> "Leer más".
		var pointerState = null;

		function onPointerDown(e) {
			if (e.button !== undefined && e.button !== 0) return;
			pointerState = {
				startX: e.clientX,
				startY: e.clientY,
				dx: 0,
				dragging: false,
				pointerId: e.pointerId
			};
		}

		function onPointerMove(e) {
			if (!pointerState) return;
			pointerState.dx = e.clientX - pointerState.startX;
			var dy = e.clientY - pointerState.startY;

			if (!pointerState.dragging) {
				if (Math.abs(pointerState.dx) > DRAG_ACTIVATE && Math.abs(pointerState.dx) > Math.abs(dy)) {
					pointerState.dragging = true;
				} else if (Math.abs(dy) > DRAG_ACTIVATE && Math.abs(dy) > Math.abs(pointerState.dx)) {
					// Scroll vertical: cancela el seguimiento de swipe.
					pointerState = null;
				}
			}
		}

		function onPointerUp(e) {
			if (!pointerState || pointerState.pointerId !== e.pointerId) return;
			var ps = pointerState;
			pointerState = null;

			// Si no fue un drag horizontal significativo: tap normal,
			// dejamos que el click fluya al <a>.
			if (!ps.dragging || Math.abs(ps.dx) < SWIPE_THRESHOLD) return;

			// Swipe confirmado: cambiamos slide programáticamente.
			// NO tocamos el evento pointerup → el click subsiguiente
			// del <a> "Leer más" sigue funcionando.
			if (ps.dx < 0) goTo(index + 1); // swipe izquierda → siguiente
			else           goTo(index - 1); // swipe derecha → anterior
		}

		function onPointerCancel() {
			pointerState = null;
		}

		if (window.PointerEvent) {
			track.addEventListener('pointerdown', onPointerDown);
			track.addEventListener('pointermove', onPointerMove);
			track.addEventListener('pointerup', onPointerUp);
			track.addEventListener('pointercancel', onPointerCancel);
		} else {
			// Fallback para navegadores antiguos sin Pointer Events.
			var touchState = null;
			track.addEventListener('touchstart', function (e) {
				if (e.touches.length !== 1) return;
				touchState = {
					startX: e.touches[0].clientX,
					startY: e.touches[0].clientY,
					dragging: false
				};
			}, { passive: true });
			track.addEventListener('touchmove', function (e) {
				if (!touchState) return;
				var dx = e.touches[0].clientX - touchState.startX;
				var dy = e.touches[0].clientY - touchState.startY;
				if (!touchState.dragging) {
					if (Math.abs(dx) > DRAG_ACTIVATE && Math.abs(dx) > Math.abs(dy)) {
						touchState.dragging = true;
					} else if (Math.abs(dy) > DRAG_ACTIVATE) {
						touchState = null;
					}
				}
			}, { passive: true });
			track.addEventListener('touchend', function (e) {
				if (!touchState) return;
				var t = e.changedTouches[0];
				var dx = t ? (t.clientX - touchState.startX) : 0;
				var dragging = touchState.dragging;
				touchState = null;
				if (!dragging || Math.abs(dx) < SWIPE_THRESHOLD) return;
				if (dx < 0) goTo(index + 1);
				else        goTo(index - 1);
			});
		}

		update();
	}

	function boot() {
		document.querySelectorAll('[data-biin-news-carousel]').forEach(init);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
